import { TopoloI18nProvider, topoloServiceUrl } from '@topolo-io/ui-kit';
import { getAppId, resolveTopoloBrowserAuthBaseUrl } from '@topolo-io/app-shell';
import { authClient } from './client/lib/topolo-auth';
import React from "react";
import { createRoot } from "react-dom/client";
import "@topolo-io/design-tokens/tokens.css";
import { App } from "./client/App";
import "@topolo-io/onboarding/styles.css";
import "@topolo-io/tour/styles.css";
import "@topolo-io/calendar/styles.css";
import "./client/styles.css";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Missing #root element");
createRoot(rootElement).render(
	<TopoloI18nProvider appId={getAppId()} revision={import.meta.env.VITE_TOPOLO_REVISION} preferencesUrl={`${resolveTopoloBrowserAuthBaseUrl()}/api/i18n/preferences`} catalogManifestUrl={topoloServiceUrl('localize', '/api/catalog-manifest')} getAccessToken={() => authClient.getAccessToken()}>
	<React.StrictMode>
		<App />
	</React.StrictMode>
	</TopoloI18nProvider>,
);
